<template>
    <v-container fluid grid-list-xl>
        <v-card flat>
            <v-card-title>
                <h4>Listado de Usuarios</h4>
                <v-spacer></v-spacer>
                <v-tooltip left color="info">
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            flat 
                            icon 
                            color="info" 
                            v-on="on"
                            @click="dialog.addClient = true; isEdit = false; clearInputs()">
                            <v-icon>
                                person_add
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Agregar nuevo usuario</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text flat class="pt-0">
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar..."
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-text>
            <v-data-table
                :headers="dataTable.headers"
                :items="dataTable.items"
                :search="search"
                :loading="listLoading"
            >
                <template v-slot:items="props">
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.role | rol }}</td>
                    <td>{{ props.item.status | status }}</td>
                    <td class="text-md-right">
                        <v-tooltip bottom color="warning">
                            <template v-slot:activator="{ on }">
                                <v-btn 
                                    flat 
                                    icon 
                                    color="warning" 
                                    v-on="on"
                                    @click="dialog.addClient = true; isEdit = true; edit( props.item.id )">
                                    <v-icon>
                                        edit
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip bottom color="error">
                            <template v-slot:activator="{ on }">
                                <v-btn 
                                    flat 
                                    icon 
                                    color="error" 
                                    v-on="on"
                                    @click="remove( props.item.id )">
                                    <v-icon>
                                        delete
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog.addClient" max-width="600px">
            <v-card>
                <v-card-title>
                    <h4 v-if="!isEdit">Nuevo Usuario</h4>
                    <h4 v-else>Editar Usuario</h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pl-0 pr-0">
                    <v-form ref="addForm">
                        <v-container class="pt-0 pb-0" grid-list-xl>
                            <v-text-field
                                v-model="form.email"
                                label="Correo Electrónico"
                                :rules="[v => !!v || 'Campo requerido']"
                                :disabled="inputDisabled">
                            </v-text-field>

                            <v-text-field
                                v-if="!isEdit"
                                v-model="form.password"
                                type="password"
                                label="Contraseña"
                                :rules="[v => !!v || 'Campo requerido']"
                                :disabled="inputDisabled">
                            </v-text-field>

                            <v-text-field
                                v-else
                                v-model="form.password"
                                type="password"
                                label="Contraseña"
                                hint="Dejar en blanco si no desea cambiarla"
                                persistent-hint
                                :disabled="inputDisabled">
                            </v-text-field>

                            <v-layout row wrap>
                                <v-flex sm12 md6>
                                    <v-select
                                        v-model="form.status"
                                        :items="basic.status"
                                        label="Estado"
                                        item-text="label"
                                        item-value="value"
                                        :rules="[v => !!v || 'Campo requerido']"
                                        :disabled="inputDisabled"
                                    ></v-select>
                                </v-flex>
                                <v-flex sm12 md6>
                                    <v-select
                                        v-model="form.role"
                                        :items="basic.rol"
                                        label="Rol del usuario"
                                        item-text="label"
                                        item-value="value"
                                        :rules="[v => !!v || 'Campo requerido']"
                                        :disabled="inputDisabled"
                                     ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        @click="dialog.addClient = false"
                        :disabled="inputDisabled">
                        Cerrar
                    </v-btn>
                    <v-btn
                        color="success"
                        @click="save()"
                        :loading="saveBtnLoading">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            bottom
            right
            :timeout="2000">
            <v-icon>
                {{ snackbar.icon }}
            </v-icon>&nbsp;
            {{ snackbar.text }}
            <v-btn
                flat
                @click="snackbar.show = false">
                <v-icon>
                    close
                </v-icon>
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import axios from "@/api/axios/config";
    export default {
        data () {
            return {
                search: '',
                inputDisabled: false,
                saveBtnLoading: false,
                listLoading: false,
                snackbar: {
                    icon: '',
                    text: '',
                    color: '',
                    show: false
                },
                dataTable: {
                    headers: [
                        {
                            text: 'Correo Electrónico',
                            value: 'email'
                        },
                        { 
                            text: 'Rol', 
                            value: 'role' 
                        },
                        { 
                            text: 'Estado', 
                            value: 'status' 
                        },
                        { 
                            text: '', 
                            value: '',
                            sortable: false, 
                        },
                    ],
                    items: []
                },
                isEdit: false,
                id: null,
                form: {
                    email: '',
                    password: '',
                    status: '',
                    role: ''
                },
                dialog: {
                    addClient: false
                },
                basic: {
                    status: [
                        { 'label': 'Activo', 'value': '1' },
                        { 'label': 'Inactivo', 'value': '0' }
                    ],
                    rol: [
                        { 'label': 'Coordinador', 'value': '4' },
                        { 'label': 'Administrador', 'value': '1' },
                         { 'label': 'Documentos', 'value': '2' },
                         { 'label': 'Archivo', 'value': '3' }
                    ]
                }
            }
        },
        filters: {
            status: function ( value ) {
                if( value == 1 ){
                    return 'Activo'
                } else {
                    return 'Inactivo'
                }
            },
            rol: function ( value ) {

                switch (value) {
                    case '1':
                        return 'Administrador'
                        break;

                    case '2':
                        return 'Documentos'
                        break;

                    case '3':
                        return 'Archivo'
                        break; 

                    case '4':
                        return 'Coordinador'
                        break;            

                    default:
                        // statements_def
                        break;
                }
                 
            }
        },
        created() {
            this.getUsers();
        },
        methods: {
            getUsers(){
                this.listLoading = true;
                axios.get( 'user' ).then( response => {
                    if( ! response.data.status ){
                        this.snackbar = {
                                icon: 'error',
                                text: response.data.message,
                                color: 'error',
                                show: true
                            };
                    } else {
                        this.dataTable.items = response.data.items;
                    }
                }).catch( error => {
                    this.snackbar = {
                            icon: 'error',
                            text: error,
                            color: 'error',
                            show: true
                        };
                }).finally( ()  => {
                    this.listLoading = false;
                });
            },
            remove( id ){
                this.$confirm('¿Realmente quieres eliminar a este usuario?').then( res => { 
                    if( res ){
                        this.listLoading = true;
                        axios.delete( 'user/' + id ).then( response => {
                            this.snackbar = {
                                icon: 'check_circle',
                                text: 'Usuario eliminado',
                                color: 'success',
                                show: true
                            };
                        }).catch( error => {
                            this.snackbar = {
                                icon: 'error',
                                text: error,
                                color: 'error',
                                show: true
                            };
                        }).finally( () => {
                            this.listLoading = false;
                            this.getUsers();
                        }); 
                    }
                });
            },
            edit( id ){
                this.saveBtnLoading = true;
                this.inputDisabled = true;
                axios.get( 'user/' + id ).then( response => {
                    this.id = response.data.data.id;
                    this.form.email = response.data.data.email;
                    this.form.status = response.data.data.status;
                    this.form.role = response.data.data.role;
                    this.inputDisabled = false;
                    this.saveBtnLoading = false;
                });
            },
            clearInputs(){
                this.id = null;
                this.$refs.addForm.reset();
                this.$refs.addForm.resetValidation();
            },
            save(){
                if( this.$refs.addForm.validate() ){
                    this.saveBtnLoading = true;
                    this.inputDisabled = true;
                    if( ! this.isEdit ){
                        axios.post( 'user', this.form ).then( response => {
                            if( response.data.status ){
                                this.snackbar = {
                                    icon: 'check_circle',
                                    text: 'Usuario creado',
                                    color: 'success',
                                    show: true
                                };
                                this.dialog.addClient = false;
                                this.clearInputs();
                            } else {
                                this.snackbar = {
                                    icon: 'error',
                                    text: response.data.response,
                                    color: 'error',
                                    show: true
                                };    
                            }
                        }).catch( error => {
                            this.snackbar = {
                                icon: 'error',
                                text: error,
                                color: 'error',
                                show: true
                            };
                        }).finally( () => {
                            this.saveBtnLoading = false;
                            this.inputDisabled = false;
                            this.getUsers();
                        });
                    } else {
                        axios.put( 'user/' + this.id, this.form ).then( response => {
                            if( response.data.status ){
                                this.snackbar = {
                                    icon: 'check_circle',
                                    text: 'Usuario editado',
                                    color: 'success',
                                    show: true
                                };
                            } else {
                                this.snackbar = {
                                    icon: 'error',
                                    text: response.data.response,
                                    color: 'error',
                                    show: true
                                };    
                            }
                        }).catch( error => {
                            this.snackbar = {
                                text: error,
                                color: 'error',
                                show: true
                            };
                        }).finally( () => {
                            this.saveBtnLoading = false;
                            this.inputDisabled = false;
                            this.getUsers();
                        });
                    }
                }
            }
        },
    }
</script>